export const FACEBOOK_MESSENGER_INFO = {
  FB_LINK: 'https://www.facebook.com/dialog/share',
  MESS_LINK: 'https://www.messenger.com/new',
};

export const GMAIL_INFO = {
  MOBILE_LINK: 'mailto:',
  WEB_LINK: 'https://mail.google.com/mail/?view=cm&fs=1&to=',
};

export const ZALO_INFO = {
  SCRIPT: 'https://sp.zalo.me/plugins/sdk.js',
  APP_COLOR: 'blue',
  CUSTOM_APP_LAYOUT: '2',
  DEFAULT_APP_LAYOUT: '1',
};

export const NEW_USER_REFERRAL_WINDOW_TIME = 1;

export const NEW_USER_REFERRAL_REWARD = 5000;

export const REFERRAL_EMAIL_TITLE =
  'Cùng biến văn bản thành giọng nói chỉ trong vài giây với Vbee!';

export const REFERRAL_CHARACTER_REWARD_STEP = 1000;

export const MIN_LENGTH_REFERRAL_CODE = 6;

export const MAX_LENGTH_REFERRAL_CODE = 50;

export const REFERRAL_SYSTEM_PREFIX = 'VBEE';

export const DELIMITER = '_';

export const REFERRAL_CODE_ALREADY_EXISTS = 8003;

export const REFERRER_REWARD_POINTS = 3;

export const CHARACTERS_PER_POINT = 1000;

export const AUTO_APPLY_REFERRAL_PARAM = 'autoApplyReferral';

export const REFERRAL_CODE_PARAM = 'ref';

export const MAX_ALLOWED_REDEEM_CHARACTERS_PER_MONTH = 300000;
